module.exports = __webpack_public_path__ + "img/PP.4713aaca.png";